import $ from 'jquery';
import { capFirst } from '../../utilities.js';
import { updateTotalPrice } from './showroom-utilities.js';
import { Formatter, PaymentCalculatorFactory } from '@dealersites/dealersite-js-core';
// import PaymentCalculatorForm from '../../components/payment-calc/payment-calculator.js';
import MicroModal from 'micromodal';
import { __ } from '@wordpress/i18n';

// Cash Incentives

const summaryBreakdown = $('.summary-cash-breakdown');

const $site = $('.site');
let FREQUENCY = $site.data('frequency');
const validFrequencies = ['weekly', 'biweekly', 'monthly'];

if (!validFrequencies.includes(FREQUENCY)) {
  FREQUENCY = 'biweekly';
}

const standardFrequency = {
  weekly: __('Weekly', 'ford-oem-theme'),
  biweekly: __('Bi-Weekly', 'ford-oem-theme'),
  monthly: __('Monthly', 'ford-oem-theme'),
};

const bottomBarTotals = {
  cash: $('.summary-cash-breakdown .bottom-bar--total'),
  finance: $('.summary-finance-breakdown .js-summary-total-price'),
  lease: $('.summary-lease-breakdown .js-summary-total-price'),
};
const configuredTotal = summaryBreakdown.data('configured');

$('.summary-cash-breakdown .js-targeted-incentive').on('change', function () {
  updateTotalPrice(configuredTotal, bottomBarTotals['cash'], 'cash');
});
$('.summary-finance-breakdown .js-targeted-incentive').on('change', function () {
  updateTotalPrice(configuredTotal, bottomBarTotals['finance'], 'finance');
});
$('.summary-lease-breakdown .js-targeted-incentive').on('change', function () {
  updateTotalPrice(configuredTotal, bottomBarTotals['lease'], 'lease');
});

// Lease/Finance Calculator
// const $downpaymentDetail = $('.js-summary-down-payment');
// const $totalPriceDetail = $('.js-summary-total-price');
// const $balanceTo = $('.js-summary-balance-to');
const $summaryModal = $('#modal-summary-payments');

const MULTIPLIERS = {
  'Bi-Weekly': 2,
  Monthly: 1,
  Weekly: 4,
};

$('.js-open-summary-payment').on('click', function () {
  const type = $(this).data('type');
  $summaryModal.find('.payment-title').each(function () {
    $(this).text(capFirst(type));
  });

  // exclusive sections - show only the section of specified type
  $summaryModal.find(`.js-exclusive-visible`).addClass('hidden');
  $summaryModal.find(`.js-exclusive-visible.summary-${type}`).removeClass('hidden');

  const formOption = $('.summary-form').find(`option[value=${capFirst(type)}]`);

  const selectOption = formOption.parents('select');

  selectOption.val(capFirst(type)).change();

  // toggle payment calculator to specified type
  $(`#show-${type}-info`).trigger('click');

  MicroModal.show('modal-summary-payments');
});

$('.term-dropdown').on('change', function () {
  const type = $(this).data('type');
  const rate = $(this).find(':selected').data('rate');
  const term = $(this).find(':selected').data('term');
  updateCount(type, term);
  $(`.js-summary-${type}-period`).text(term);
  $(`.js-summary-${type}-rate`).text(Formatter.number(rate, 2));

  if (type == 'lease') {
    const residual = $(this).find(':selected').data('residual');
    $(`.js-summary-${type}-residual`).text(Formatter.price(residual));
  }
});

$('.summary-payment').each(function () {
  const type = $(this).data('type');
  let calcInputs = {
    price: $(this).data('price'),
    down: 0,
    term: $(this).data('term'),
    rate: $(this).data('rate'),
    tradein: 0,
    tax: 0,
  };

  if (type === 'lease') {
    calcInputs.residual = $(this).data('residual');
  }

  const financeCalc = PaymentCalculatorFactory.createCalculator(type, calcInputs);

  financeCalc.calculate();
  $(this).text(Formatter.price(financeCalc.payments[FREQUENCY], 0));
});

$('.payment-frequency-button').on('change', function () {
  const frequency = $(this).siblings('label').text().trim();
  ['lease', 'finance'].forEach(function (type) {
    const term = $(`#js-calc-small-${type}-term`).find(':selected').data('term');
    updateCount(type, term, frequency);
  });
});

$('.back-to-configure').on('click', function(e) {
  // e.preventDefault();
  history.back();
})

function updateCount(type, term, frequency = null) {
  const frequencyText = frequency ?? $(`.js-summary-${type}-frequency`).text().trim();

  const count = term * MULTIPLIERS[frequencyText];

  $(`.js-summary-${type}-count`).text(Formatter.number(count, 0));
  $(`.js-summary-${type}-frequency`).text(frequencyText);
}